angular.module('core')
  .directive("errorMessages", function() {
    return {
      restrict: "EC",
      scope: {
        message: '=message'
      },
      templateUrl: '/resources/core/partials/error-messages.html'
    };
    });
